export default __webpack_public_path__ + "static/uk-career-development-awards-2020-7a18d08d413c9b51f0c11cd8ecf91903.png";